module.exports = __webpack_public_path__ + "assets/img/14_917_big.53845608.jpg";